import { isGodRole } from "@/lib/permissions";

const SUPPORT_PLATFORM_EMAILS: readonly string[] = [
  "crisner@transparentimaging.com",
  "nemccabe@transparentimaging.com",
];

export function canDownloadSupportPlatform(roles: string[], email: string | undefined): boolean {
  if (isGodRole(roles)) return true;
  const normalized = email?.trim().toLowerCase();
  return normalized !== undefined && SUPPORT_PLATFORM_EMAILS.includes(normalized);
}
